import { useEffect, useState } from 'react'
import './App.css'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

// Setup important consts
// The url of the app you want the auth to redirect to after user completes auth process
// Note: This is usually the url of the calling app
const redirect = 'http://localhost:3000';

// The developer provided appId that is initialising the auth flow
const appId = 'vBUY8CYxMHrjFJEEIRwCihU3ndzDkLyl';

// The url to the auth app
const authUrl = 'https://auth.rovjok.com/';

// The api uri to convert the code to a token
const authServerUrl = 'https://rovjok-appownsdatawebapi.azurewebsites.net/api/auth/access-code/token'


function CallbackView() {
  // Store the code in state for reactivity
  const [code] = useState(new URLSearchParams(window.location.search).get('code'));
  const [jwt] = useState(localStorage.getItem('accessToken'));
  const navigate = useNavigate();

  useEffect(() => {
    if (!code) return;

    const c = decodeURIComponent(code as string)

    axios.post(authServerUrl, { code }).then(r => {
      console.log('access', r.data)
      // store the token
      const token = decodeURIComponent(r.data)
      localStorage.setItem('accessToken', token);
      console.log('token stored')
      navigate('/');
    })
  }, [code])


  // Initialize the auth flow
  const beginAuth = () => {
    // Clear the current token
    localStorage.removeItem('accessToken');

    // Redirect to the auth app
    window.location.replace(`${authUrl}?redirect=${redirect}&appId=${appId}`)
  };


  return (
    <div>loading....</div>
  )
}

export default CallbackView
